// language=GraphQL
export const ALL_TENANTS_QUERY = `query Query($withCms: Boolean = false, $withCmsHomepage: Boolean = false, $withCmsHomepageSeoSettings: Boolean = false, $withCmsHomepageContentBlockAssignments: Boolean = false, $withCmsCategories: Boolean = false, $withCmsCategoriesPages: Boolean = false, $withCmsCategoriesSeoSettings: Boolean = false, $withCmsPages: Boolean = false, $withCmsPagesSeoSettings: Boolean = false, $withCmsPagesContentBlockAssignments: Boolean = false, $withCmsErrorPage404: Boolean = false, $withCmsErrorPage404SeoSettings: Boolean = false, $withCmsErrorPage404ContentBlockAssignments: Boolean = false, $withCmsErrorPage500: Boolean = false, $withCmsErrorPage500SeoSettings: Boolean = false, $withCmsErrorPage500ContentBlockAssignments: Boolean = false, $withCmsConfig: Boolean = false, $withCmsConfigContactBlockSettings: Boolean = false, $withCmsConfigSocialMediaSettings: Boolean = false, $withCmsConfigPrivacyPolicyPage: Boolean = false, $withCmsConfigGtcPage: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false, $withEmailConfig: Boolean = false, $withNewsletterProvider: Boolean = false, $withNewsletterProviderConfig: Boolean = false, $withRedirects: Boolean = false, $withRedirectsFromPage: Boolean = false, $withRedirectsFromPageSeoSettings: Boolean = false, $withRedirectsFromPageContentBlockAssignments: Boolean = false, $withRedirectsFromTravel: Boolean = false, $withRedirectsFromTravelAvailabilityStatus: Boolean = false, $withRedirectsFromTravelTravelConsultant: Boolean = false, $withRedirectsFromTravelLabel: Boolean = false, $withRedirectsFromTravelSeoSettings: Boolean = false, $withRedirectsFromTravelTenantSettings: Boolean = false, $withRedirectsFromTravelHighlights: Boolean = false, $withRedirectsFromTravelPartners: Boolean = false, $withRedirectsFromTravelTravelGuides: Boolean = false, $withRedirectsFromTravelTeams: Boolean = false, $withRedirectsFromTravelAccommodationAssignments: Boolean = false, $withRedirectsFromTravelAccommodations: Boolean = false, $withRedirectsFromTravelDestinations: Boolean = false, $withRedirectsFromTravelTestimonials: Boolean = false, $withRedirectsFromTravelMainImage: Boolean = false, $withRedirectsFromTravelMainVideo: Boolean = false, $withRedirectsFromTravelGallery: Boolean = false, $withRedirectsFromTravelTravelPdf: Boolean = false, $withRedirectsFromTravelTravelExtensions: Boolean = false, $withRedirectsFromTravelItinerary: Boolean = false, $withRedirectsFromTravelPricing: Boolean = false, $withRedirectsToPage: Boolean = false, $withRedirectsToPageSeoSettings: Boolean = false, $withRedirectsToPageContentBlockAssignments: Boolean = false, $withRedirectsToTravel: Boolean = false, $withRedirectsToTravelAvailabilityStatus: Boolean = false, $withRedirectsToTravelTravelConsultant: Boolean = false, $withRedirectsToTravelLabel: Boolean = false, $withRedirectsToTravelSeoSettings: Boolean = false, $withRedirectsToTravelTenantSettings: Boolean = false, $withRedirectsToTravelHighlights: Boolean = false, $withRedirectsToTravelPartners: Boolean = false, $withRedirectsToTravelTravelGuides: Boolean = false, $withRedirectsToTravelTeams: Boolean = false, $withRedirectsToTravelAccommodationAssignments: Boolean = false, $withRedirectsToTravelAccommodations: Boolean = false, $withRedirectsToTravelDestinations: Boolean = false, $withRedirectsToTravelTestimonials: Boolean = false, $withRedirectsToTravelMainImage: Boolean = false, $withRedirectsToTravelMainVideo: Boolean = false, $withRedirectsToTravelGallery: Boolean = false, $withRedirectsToTravelTravelPdf: Boolean = false, $withRedirectsToTravelTravelExtensions: Boolean = false, $withRedirectsToTravelItinerary: Boolean = false, $withRedirectsToTravelPricing: Boolean = false, $withOnlinePaymentConfig: Boolean = false, $withRatioConfig: Boolean = false, $withContent: Boolean = false, $withPartnerTenants: Boolean = false, $withPartnerTenantsTenant: Boolean = false, $withPartnerTenantsTenantCms: Boolean = false, $withPartnerTenantsTenantTravelTypes: Boolean = false, $withPartnerTenantsTenantEmployees: Boolean = false, $withPartnerTenantsTenantEmailConfig: Boolean = false, $withPartnerTenantsTenantNewsletterProvider: Boolean = false, $withPartnerTenantsTenantRedirects: Boolean = false, $withPartnerTenantsTenantOnlinePaymentConfig: Boolean = false, $withPartnerTenantsTenantRatioConfig: Boolean = false, $withPartnerTenantsTenantContent: Boolean = false, $withPartnerTenantsTenantPartnerTenants: Boolean = false) {
  tenants: tenants {
    id
    name
    slug
    domain
    externalReference
    cms @include(if: $withCms) {
      id
      homepage @include(if: $withCmsHomepage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withCmsHomepageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withCmsHomepageContentBlockAssignments) {
          id
          type
        }
      }
      categories @include(if: $withCmsCategories) {
        id
        name
        pages @include(if: $withCmsCategoriesPages) {
          id
          name
          onlineStatus
        }
        seoSettings @include(if: $withCmsCategoriesSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
      }
      pages @include(if: $withCmsPages) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withCmsPagesSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withCmsPagesContentBlockAssignments) {
          id
          type
        }
      }
      errorPage404 @include(if: $withCmsErrorPage404) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withCmsErrorPage404SeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withCmsErrorPage404ContentBlockAssignments) {
          id
          type
        }
      }
      errorPage500 @include(if: $withCmsErrorPage500) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withCmsErrorPage500SeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withCmsErrorPage500ContentBlockAssignments) {
          id
          type
        }
      }
      config @include(if: $withCmsConfig) {
        id
        contactBlockSettings @include(if: $withCmsConfigContactBlockSettings) {
          id
          slogan
          title
          text
          phonePrefix
          phone
          phone2Prefix
          phone2
          openingHours1
          openingHours2
          email
        }
        socialMediaSettings @include(if: $withCmsConfigSocialMediaSettings) {
          id
          facebookUrl
          instagramUrl
        }
        privacyPolicyPage @include(if: $withCmsConfigPrivacyPolicyPage) {
          id
          name
          onlineStatus
        }
        gtcPage @include(if: $withCmsConfigGtcPage) {
          id
          name
          onlineStatus
        }
      }
    }
    travelTypes @include(if: $withTravelTypes) {
      id
      name
      description
      image @include(if: $withTravelTypesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    employees @include(if: $withEmployees) {
      id
      firstName
      lastName
      jobTitle
      description
      email
      image @include(if: $withEmployeesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      phone
    }
    emailConfig @include(if: $withEmailConfig) {
      id
      defaultInternalRecipientEmail
      internalBookingRecipientEmails
      bookingConfirmationTemplateId
      bookingConfirmationInternalTemplateId
      bookingRequestConfirmationTemplateId
      bookingWaitlistConfirmationTemplateId
      bookingWaitlistContingentCheckConfirmationTemplateId
      bookingCustomRequestTemplateId
      bookingPassportDataReminderTemplateId
      contactFormTemplateId
      esimInstallationInfoTemplateId
    }
    newsletterProvider @include(if: $withNewsletterProvider) {
      id
      provider
      config @include(if: $withNewsletterProviderConfig) {
        __typename
        ... on MailchimpConfig {
          id
          apiKey
          serverPrefix
          listId

        }
      }
    }
    redirects @include(if: $withRedirects) {
      id
      fromType
      fromUrl
      fromPage @include(if: $withRedirectsFromPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withRedirectsFromPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withRedirectsFromPageContentBlockAssignments) {
          id
          type
        }
      }
      fromTravel @include(if: $withRedirectsFromTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withRedirectsFromTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        executionStatus
        travelConsultant @include(if: $withRedirectsFromTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        label @include(if: $withRedirectsFromTravelLabel) {
          id
          label
        }
        title
        description
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withRedirectsFromTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        tenantSettings @include(if: $withRedirectsFromTravelTenantSettings) {
          id
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
        }
        highlights @include(if: $withRedirectsFromTravelHighlights) {
          id
          text
        }
        partners @include(if: $withRedirectsFromTravelPartners) {
          id
          name
          url
          logoWidth
        }
        travelGuides @include(if: $withRedirectsFromTravelTravelGuides) {
          id
          firstName
          lastName
          description
        }
        teams @include(if: $withRedirectsFromTravelTeams) {
          id
          name
        }
        accommodationAssignments @include(if: $withRedirectsFromTravelAccommodationAssignments) {
          id
          useCustomRoomTypeSelection
        }
        accommodations @include(if: $withRedirectsFromTravelAccommodations) {
          id
          label
          name
          stars
          description
        }
        destinations @include(if: $withRedirectsFromTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withRedirectsFromTravelTestimonials) {
          id
        }
        mainImage @include(if: $withRedirectsFromTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withRedirectsFromTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withRedirectsFromTravelGallery) {
          id
        }
        travelPdf @include(if: $withRedirectsFromTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withRedirectsFromTravelTravelExtensions) {
          id
          duration
          name
          description
        }
        programType
        itinerary @include(if: $withRedirectsFromTravelItinerary) {
          id
        }
        programText
        pricing @include(if: $withRedirectsFromTravelPricing) {
          id
          isTravelDocumentationAvailable
        }
        minPrice
        minPriceManualOverride
        currency
      }
      toType
      toUrl
      toPage @include(if: $withRedirectsToPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withRedirectsToPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withRedirectsToPageContentBlockAssignments) {
          id
          type
        }
      }
      toTravel @include(if: $withRedirectsToTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withRedirectsToTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        executionStatus
        travelConsultant @include(if: $withRedirectsToTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        label @include(if: $withRedirectsToTravelLabel) {
          id
          label
        }
        title
        description
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withRedirectsToTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        tenantSettings @include(if: $withRedirectsToTravelTenantSettings) {
          id
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
        }
        highlights @include(if: $withRedirectsToTravelHighlights) {
          id
          text
        }
        partners @include(if: $withRedirectsToTravelPartners) {
          id
          name
          url
          logoWidth
        }
        travelGuides @include(if: $withRedirectsToTravelTravelGuides) {
          id
          firstName
          lastName
          description
        }
        teams @include(if: $withRedirectsToTravelTeams) {
          id
          name
        }
        accommodationAssignments @include(if: $withRedirectsToTravelAccommodationAssignments) {
          id
          useCustomRoomTypeSelection
        }
        accommodations @include(if: $withRedirectsToTravelAccommodations) {
          id
          label
          name
          stars
          description
        }
        destinations @include(if: $withRedirectsToTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withRedirectsToTravelTestimonials) {
          id
        }
        mainImage @include(if: $withRedirectsToTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withRedirectsToTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withRedirectsToTravelGallery) {
          id
        }
        travelPdf @include(if: $withRedirectsToTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withRedirectsToTravelTravelExtensions) {
          id
          duration
          name
          description
        }
        programType
        itinerary @include(if: $withRedirectsToTravelItinerary) {
          id
        }
        programText
        pricing @include(if: $withRedirectsToTravelPricing) {
          id
          isTravelDocumentationAvailable
        }
        minPrice
        minPriceManualOverride
        currency
      }
    }
    onlinePaymentConfig @include(if: $withOnlinePaymentConfig) {
      id
      enabled
      ratioFibuAccountNo
      infoText
      datatransThemeConfig
    }
    ratioConfig @include(if: $withRatioConfig) {
      id
      adressgruppe
    }
    content @include(if: $withContent) {
      id
      bookingInsuranceInfo
    }
    partnerTenants @include(if: $withPartnerTenants) {
      id
      tenant @include(if: $withPartnerTenantsTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withPartnerTenantsTenantCms) {
          id
        }
        travelTypes @include(if: $withPartnerTenantsTenantTravelTypes) {
          id
          name
          description
        }
        employees @include(if: $withPartnerTenantsTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        emailConfig @include(if: $withPartnerTenantsTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withPartnerTenantsTenantNewsletterProvider) {
          id
          provider
        }
        redirects @include(if: $withPartnerTenantsTenantRedirects) {
          id
          fromType
          fromUrl
          toType
          toUrl
        }
        onlinePaymentConfig @include(if: $withPartnerTenantsTenantOnlinePaymentConfig) {
          id
          enabled
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withPartnerTenantsTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withPartnerTenantsTenantContent) {
          id
          bookingInsuranceInfo
        }
        partnerTenants @include(if: $withPartnerTenantsTenantPartnerTenants) {
          id
          filterCrossLinking
        }
      }
      filterCrossLinking
    }
  }
}`

// language=GraphQL
export const SINGLE_TENANT_QUERY = `query Query($id: ID!, $withCms: Boolean = false, $withCmsHomepage: Boolean = false, $withCmsHomepageSeoSettings: Boolean = false, $withCmsHomepageContentBlockAssignments: Boolean = false, $withCmsCategories: Boolean = false, $withCmsCategoriesPages: Boolean = false, $withCmsCategoriesSeoSettings: Boolean = false, $withCmsPages: Boolean = false, $withCmsPagesSeoSettings: Boolean = false, $withCmsPagesContentBlockAssignments: Boolean = false, $withCmsErrorPage404: Boolean = false, $withCmsErrorPage404SeoSettings: Boolean = false, $withCmsErrorPage404ContentBlockAssignments: Boolean = false, $withCmsErrorPage500: Boolean = false, $withCmsErrorPage500SeoSettings: Boolean = false, $withCmsErrorPage500ContentBlockAssignments: Boolean = false, $withCmsConfig: Boolean = false, $withCmsConfigContactBlockSettings: Boolean = false, $withCmsConfigSocialMediaSettings: Boolean = false, $withCmsConfigPrivacyPolicyPage: Boolean = false, $withCmsConfigGtcPage: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false, $withEmailConfig: Boolean = false, $withNewsletterProvider: Boolean = false, $withNewsletterProviderConfig: Boolean = false, $withRedirects: Boolean = false, $withRedirectsFromPage: Boolean = false, $withRedirectsFromPageSeoSettings: Boolean = false, $withRedirectsFromPageContentBlockAssignments: Boolean = false, $withRedirectsFromTravel: Boolean = false, $withRedirectsFromTravelAvailabilityStatus: Boolean = false, $withRedirectsFromTravelTravelConsultant: Boolean = false, $withRedirectsFromTravelLabel: Boolean = false, $withRedirectsFromTravelSeoSettings: Boolean = false, $withRedirectsFromTravelTenantSettings: Boolean = false, $withRedirectsFromTravelHighlights: Boolean = false, $withRedirectsFromTravelPartners: Boolean = false, $withRedirectsFromTravelTravelGuides: Boolean = false, $withRedirectsFromTravelTeams: Boolean = false, $withRedirectsFromTravelAccommodationAssignments: Boolean = false, $withRedirectsFromTravelAccommodations: Boolean = false, $withRedirectsFromTravelDestinations: Boolean = false, $withRedirectsFromTravelTestimonials: Boolean = false, $withRedirectsFromTravelMainImage: Boolean = false, $withRedirectsFromTravelMainVideo: Boolean = false, $withRedirectsFromTravelGallery: Boolean = false, $withRedirectsFromTravelTravelPdf: Boolean = false, $withRedirectsFromTravelTravelExtensions: Boolean = false, $withRedirectsFromTravelItinerary: Boolean = false, $withRedirectsFromTravelPricing: Boolean = false, $withRedirectsToPage: Boolean = false, $withRedirectsToPageSeoSettings: Boolean = false, $withRedirectsToPageContentBlockAssignments: Boolean = false, $withRedirectsToTravel: Boolean = false, $withRedirectsToTravelAvailabilityStatus: Boolean = false, $withRedirectsToTravelTravelConsultant: Boolean = false, $withRedirectsToTravelLabel: Boolean = false, $withRedirectsToTravelSeoSettings: Boolean = false, $withRedirectsToTravelTenantSettings: Boolean = false, $withRedirectsToTravelHighlights: Boolean = false, $withRedirectsToTravelPartners: Boolean = false, $withRedirectsToTravelTravelGuides: Boolean = false, $withRedirectsToTravelTeams: Boolean = false, $withRedirectsToTravelAccommodationAssignments: Boolean = false, $withRedirectsToTravelAccommodations: Boolean = false, $withRedirectsToTravelDestinations: Boolean = false, $withRedirectsToTravelTestimonials: Boolean = false, $withRedirectsToTravelMainImage: Boolean = false, $withRedirectsToTravelMainVideo: Boolean = false, $withRedirectsToTravelGallery: Boolean = false, $withRedirectsToTravelTravelPdf: Boolean = false, $withRedirectsToTravelTravelExtensions: Boolean = false, $withRedirectsToTravelItinerary: Boolean = false, $withRedirectsToTravelPricing: Boolean = false, $withOnlinePaymentConfig: Boolean = false, $withRatioConfig: Boolean = false, $withContent: Boolean = false, $withPartnerTenants: Boolean = false, $withPartnerTenantsTenant: Boolean = false, $withPartnerTenantsTenantCms: Boolean = false, $withPartnerTenantsTenantTravelTypes: Boolean = false, $withPartnerTenantsTenantEmployees: Boolean = false, $withPartnerTenantsTenantEmailConfig: Boolean = false, $withPartnerTenantsTenantNewsletterProvider: Boolean = false, $withPartnerTenantsTenantRedirects: Boolean = false, $withPartnerTenantsTenantOnlinePaymentConfig: Boolean = false, $withPartnerTenantsTenantRatioConfig: Boolean = false, $withPartnerTenantsTenantContent: Boolean = false, $withPartnerTenantsTenantPartnerTenants: Boolean = false) {
  tenant: tenant(id: $id) {
    id
    name
    slug
    domain
    externalReference
    cms @include(if: $withCms) {
      id
      homepage @include(if: $withCmsHomepage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withCmsHomepageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withCmsHomepageContentBlockAssignments) {
          id
          type
        }
      }
      categories @include(if: $withCmsCategories) {
        id
        name
        pages @include(if: $withCmsCategoriesPages) {
          id
          name
          onlineStatus
        }
        seoSettings @include(if: $withCmsCategoriesSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
      }
      pages @include(if: $withCmsPages) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withCmsPagesSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withCmsPagesContentBlockAssignments) {
          id
          type
        }
      }
      errorPage404 @include(if: $withCmsErrorPage404) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withCmsErrorPage404SeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withCmsErrorPage404ContentBlockAssignments) {
          id
          type
        }
      }
      errorPage500 @include(if: $withCmsErrorPage500) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withCmsErrorPage500SeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withCmsErrorPage500ContentBlockAssignments) {
          id
          type
        }
      }
      config @include(if: $withCmsConfig) {
        id
        contactBlockSettings @include(if: $withCmsConfigContactBlockSettings) {
          id
          slogan
          title
          text
          phonePrefix
          phone
          phone2Prefix
          phone2
          openingHours1
          openingHours2
          email
        }
        socialMediaSettings @include(if: $withCmsConfigSocialMediaSettings) {
          id
          facebookUrl
          instagramUrl
        }
        privacyPolicyPage @include(if: $withCmsConfigPrivacyPolicyPage) {
          id
          name
          onlineStatus
        }
        gtcPage @include(if: $withCmsConfigGtcPage) {
          id
          name
          onlineStatus
        }
      }
    }
    travelTypes @include(if: $withTravelTypes) {
      id
      name
      description
      image @include(if: $withTravelTypesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
    employees @include(if: $withEmployees) {
      id
      firstName
      lastName
      jobTitle
      description
      email
      image @include(if: $withEmployeesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      phone
    }
    emailConfig @include(if: $withEmailConfig) {
      id
      defaultInternalRecipientEmail
      internalBookingRecipientEmails
      bookingConfirmationTemplateId
      bookingConfirmationInternalTemplateId
      bookingRequestConfirmationTemplateId
      bookingWaitlistConfirmationTemplateId
      bookingWaitlistContingentCheckConfirmationTemplateId
      bookingCustomRequestTemplateId
      bookingPassportDataReminderTemplateId
      contactFormTemplateId
      esimInstallationInfoTemplateId
    }
    newsletterProvider @include(if: $withNewsletterProvider) {
      id
      provider
      config @include(if: $withNewsletterProviderConfig) {
        __typename
        ... on MailchimpConfig {
          id
          apiKey
          serverPrefix
          listId

        }
      }
    }
    redirects @include(if: $withRedirects) {
      id
      fromType
      fromUrl
      fromPage @include(if: $withRedirectsFromPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withRedirectsFromPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withRedirectsFromPageContentBlockAssignments) {
          id
          type
        }
      }
      fromTravel @include(if: $withRedirectsFromTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withRedirectsFromTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        executionStatus
        travelConsultant @include(if: $withRedirectsFromTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        label @include(if: $withRedirectsFromTravelLabel) {
          id
          label
        }
        title
        description
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withRedirectsFromTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        tenantSettings @include(if: $withRedirectsFromTravelTenantSettings) {
          id
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
        }
        highlights @include(if: $withRedirectsFromTravelHighlights) {
          id
          text
        }
        partners @include(if: $withRedirectsFromTravelPartners) {
          id
          name
          url
          logoWidth
        }
        travelGuides @include(if: $withRedirectsFromTravelTravelGuides) {
          id
          firstName
          lastName
          description
        }
        teams @include(if: $withRedirectsFromTravelTeams) {
          id
          name
        }
        accommodationAssignments @include(if: $withRedirectsFromTravelAccommodationAssignments) {
          id
          useCustomRoomTypeSelection
        }
        accommodations @include(if: $withRedirectsFromTravelAccommodations) {
          id
          label
          name
          stars
          description
        }
        destinations @include(if: $withRedirectsFromTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withRedirectsFromTravelTestimonials) {
          id
        }
        mainImage @include(if: $withRedirectsFromTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withRedirectsFromTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withRedirectsFromTravelGallery) {
          id
        }
        travelPdf @include(if: $withRedirectsFromTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withRedirectsFromTravelTravelExtensions) {
          id
          duration
          name
          description
        }
        programType
        itinerary @include(if: $withRedirectsFromTravelItinerary) {
          id
        }
        programText
        pricing @include(if: $withRedirectsFromTravelPricing) {
          id
          isTravelDocumentationAvailable
        }
        minPrice
        minPriceManualOverride
        currency
      }
      toType
      toUrl
      toPage @include(if: $withRedirectsToPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withRedirectsToPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withRedirectsToPageContentBlockAssignments) {
          id
          type
        }
      }
      toTravel @include(if: $withRedirectsToTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withRedirectsToTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        executionStatus
        travelConsultant @include(if: $withRedirectsToTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        label @include(if: $withRedirectsToTravelLabel) {
          id
          label
        }
        title
        description
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withRedirectsToTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        tenantSettings @include(if: $withRedirectsToTravelTenantSettings) {
          id
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
        }
        highlights @include(if: $withRedirectsToTravelHighlights) {
          id
          text
        }
        partners @include(if: $withRedirectsToTravelPartners) {
          id
          name
          url
          logoWidth
        }
        travelGuides @include(if: $withRedirectsToTravelTravelGuides) {
          id
          firstName
          lastName
          description
        }
        teams @include(if: $withRedirectsToTravelTeams) {
          id
          name
        }
        accommodationAssignments @include(if: $withRedirectsToTravelAccommodationAssignments) {
          id
          useCustomRoomTypeSelection
        }
        accommodations @include(if: $withRedirectsToTravelAccommodations) {
          id
          label
          name
          stars
          description
        }
        destinations @include(if: $withRedirectsToTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withRedirectsToTravelTestimonials) {
          id
        }
        mainImage @include(if: $withRedirectsToTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withRedirectsToTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withRedirectsToTravelGallery) {
          id
        }
        travelPdf @include(if: $withRedirectsToTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withRedirectsToTravelTravelExtensions) {
          id
          duration
          name
          description
        }
        programType
        itinerary @include(if: $withRedirectsToTravelItinerary) {
          id
        }
        programText
        pricing @include(if: $withRedirectsToTravelPricing) {
          id
          isTravelDocumentationAvailable
        }
        minPrice
        minPriceManualOverride
        currency
      }
    }
    onlinePaymentConfig @include(if: $withOnlinePaymentConfig) {
      id
      enabled
      ratioFibuAccountNo
      infoText
      datatransThemeConfig
    }
    ratioConfig @include(if: $withRatioConfig) {
      id
      adressgruppe
    }
    content @include(if: $withContent) {
      id
      bookingInsuranceInfo
    }
    partnerTenants @include(if: $withPartnerTenants) {
      id
      tenant @include(if: $withPartnerTenantsTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withPartnerTenantsTenantCms) {
          id
        }
        travelTypes @include(if: $withPartnerTenantsTenantTravelTypes) {
          id
          name
          description
        }
        employees @include(if: $withPartnerTenantsTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        emailConfig @include(if: $withPartnerTenantsTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withPartnerTenantsTenantNewsletterProvider) {
          id
          provider
        }
        redirects @include(if: $withPartnerTenantsTenantRedirects) {
          id
          fromType
          fromUrl
          toType
          toUrl
        }
        onlinePaymentConfig @include(if: $withPartnerTenantsTenantOnlinePaymentConfig) {
          id
          enabled
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withPartnerTenantsTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withPartnerTenantsTenantContent) {
          id
          bookingInsuranceInfo
        }
        partnerTenants @include(if: $withPartnerTenantsTenantPartnerTenants) {
          id
          filterCrossLinking
        }
      }
      filterCrossLinking
    }
  }
}`

// language=GraphQL
export const CREATE_TENANT_MUTATION = `
  mutation Mutation($input: CreateTenantInput, $withCms: Boolean = false, $withCmsHomepage: Boolean = false, $withCmsHomepageSeoSettings: Boolean = false, $withCmsHomepageContentBlockAssignments: Boolean = false, $withCmsCategories: Boolean = false, $withCmsCategoriesPages: Boolean = false, $withCmsCategoriesSeoSettings: Boolean = false, $withCmsPages: Boolean = false, $withCmsPagesSeoSettings: Boolean = false, $withCmsPagesContentBlockAssignments: Boolean = false, $withCmsErrorPage404: Boolean = false, $withCmsErrorPage404SeoSettings: Boolean = false, $withCmsErrorPage404ContentBlockAssignments: Boolean = false, $withCmsErrorPage500: Boolean = false, $withCmsErrorPage500SeoSettings: Boolean = false, $withCmsErrorPage500ContentBlockAssignments: Boolean = false, $withCmsConfig: Boolean = false, $withCmsConfigContactBlockSettings: Boolean = false, $withCmsConfigSocialMediaSettings: Boolean = false, $withCmsConfigPrivacyPolicyPage: Boolean = false, $withCmsConfigGtcPage: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false, $withEmailConfig: Boolean = false, $withNewsletterProvider: Boolean = false, $withNewsletterProviderConfig: Boolean = false, $withRedirects: Boolean = false, $withRedirectsFromPage: Boolean = false, $withRedirectsFromPageSeoSettings: Boolean = false, $withRedirectsFromPageContentBlockAssignments: Boolean = false, $withRedirectsFromTravel: Boolean = false, $withRedirectsFromTravelAvailabilityStatus: Boolean = false, $withRedirectsFromTravelTravelConsultant: Boolean = false, $withRedirectsFromTravelLabel: Boolean = false, $withRedirectsFromTravelSeoSettings: Boolean = false, $withRedirectsFromTravelTenantSettings: Boolean = false, $withRedirectsFromTravelHighlights: Boolean = false, $withRedirectsFromTravelPartners: Boolean = false, $withRedirectsFromTravelTravelGuides: Boolean = false, $withRedirectsFromTravelTeams: Boolean = false, $withRedirectsFromTravelAccommodationAssignments: Boolean = false, $withRedirectsFromTravelAccommodations: Boolean = false, $withRedirectsFromTravelDestinations: Boolean = false, $withRedirectsFromTravelTestimonials: Boolean = false, $withRedirectsFromTravelMainImage: Boolean = false, $withRedirectsFromTravelMainVideo: Boolean = false, $withRedirectsFromTravelGallery: Boolean = false, $withRedirectsFromTravelTravelPdf: Boolean = false, $withRedirectsFromTravelTravelExtensions: Boolean = false, $withRedirectsFromTravelItinerary: Boolean = false, $withRedirectsFromTravelPricing: Boolean = false, $withRedirectsToPage: Boolean = false, $withRedirectsToPageSeoSettings: Boolean = false, $withRedirectsToPageContentBlockAssignments: Boolean = false, $withRedirectsToTravel: Boolean = false, $withRedirectsToTravelAvailabilityStatus: Boolean = false, $withRedirectsToTravelTravelConsultant: Boolean = false, $withRedirectsToTravelLabel: Boolean = false, $withRedirectsToTravelSeoSettings: Boolean = false, $withRedirectsToTravelTenantSettings: Boolean = false, $withRedirectsToTravelHighlights: Boolean = false, $withRedirectsToTravelPartners: Boolean = false, $withRedirectsToTravelTravelGuides: Boolean = false, $withRedirectsToTravelTeams: Boolean = false, $withRedirectsToTravelAccommodationAssignments: Boolean = false, $withRedirectsToTravelAccommodations: Boolean = false, $withRedirectsToTravelDestinations: Boolean = false, $withRedirectsToTravelTestimonials: Boolean = false, $withRedirectsToTravelMainImage: Boolean = false, $withRedirectsToTravelMainVideo: Boolean = false, $withRedirectsToTravelGallery: Boolean = false, $withRedirectsToTravelTravelPdf: Boolean = false, $withRedirectsToTravelTravelExtensions: Boolean = false, $withRedirectsToTravelItinerary: Boolean = false, $withRedirectsToTravelPricing: Boolean = false, $withOnlinePaymentConfig: Boolean = false, $withRatioConfig: Boolean = false, $withContent: Boolean = false, $withPartnerTenants: Boolean = false, $withPartnerTenantsTenant: Boolean = false, $withPartnerTenantsTenantCms: Boolean = false, $withPartnerTenantsTenantTravelTypes: Boolean = false, $withPartnerTenantsTenantEmployees: Boolean = false, $withPartnerTenantsTenantEmailConfig: Boolean = false, $withPartnerTenantsTenantNewsletterProvider: Boolean = false, $withPartnerTenantsTenantRedirects: Boolean = false, $withPartnerTenantsTenantOnlinePaymentConfig: Boolean = false, $withPartnerTenantsTenantRatioConfig: Boolean = false, $withPartnerTenantsTenantContent: Boolean = false, $withPartnerTenantsTenantPartnerTenants: Boolean = false) {
    tenant: createTenant(input: $input) {
      id
      name
      slug
      domain
      externalReference
      cms @include(if: $withCms) {
        id
        homepage @include(if: $withCmsHomepage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withCmsHomepageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withCmsHomepageContentBlockAssignments) {
            id
            type
          }
        }
        categories @include(if: $withCmsCategories) {
          id
          name
          pages @include(if: $withCmsCategoriesPages) {
            id
            name
            onlineStatus
          }
          seoSettings @include(if: $withCmsCategoriesSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
        }
        pages @include(if: $withCmsPages) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withCmsPagesSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withCmsPagesContentBlockAssignments) {
            id
            type
          }
        }
        errorPage404 @include(if: $withCmsErrorPage404) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withCmsErrorPage404SeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withCmsErrorPage404ContentBlockAssignments) {
            id
            type
          }
        }
        errorPage500 @include(if: $withCmsErrorPage500) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withCmsErrorPage500SeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withCmsErrorPage500ContentBlockAssignments) {
            id
            type
          }
        }
        config @include(if: $withCmsConfig) {
          id
          contactBlockSettings @include(if: $withCmsConfigContactBlockSettings) {
            id
            slogan
            title
            text
            phonePrefix
            phone
            phone2Prefix
            phone2
            openingHours1
            openingHours2
            email
          }
          socialMediaSettings @include(if: $withCmsConfigSocialMediaSettings) {
            id
            facebookUrl
            instagramUrl
          }
          privacyPolicyPage @include(if: $withCmsConfigPrivacyPolicyPage) {
            id
            name
            onlineStatus
          }
          gtcPage @include(if: $withCmsConfigGtcPage) {
            id
            name
            onlineStatus
          }
        }
      }
      travelTypes @include(if: $withTravelTypes) {
        id
        name
        description
        image @include(if: $withTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      employees @include(if: $withEmployees) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withEmployeesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      emailConfig @include(if: $withEmailConfig) {
        id
        defaultInternalRecipientEmail
        internalBookingRecipientEmails
        bookingConfirmationTemplateId
        bookingConfirmationInternalTemplateId
        bookingRequestConfirmationTemplateId
        bookingWaitlistConfirmationTemplateId
        bookingWaitlistContingentCheckConfirmationTemplateId
        bookingCustomRequestTemplateId
        bookingPassportDataReminderTemplateId
        contactFormTemplateId
        esimInstallationInfoTemplateId
      }
      newsletterProvider @include(if: $withNewsletterProvider) {
        id
        provider
        config @include(if: $withNewsletterProviderConfig) {
          __typename
          ... on MailchimpConfig {
            id
            apiKey
            serverPrefix
            listId

          }
        }
      }
      redirects @include(if: $withRedirects) {
        id
        fromType
        fromUrl
        fromPage @include(if: $withRedirectsFromPage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withRedirectsFromPageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withRedirectsFromPageContentBlockAssignments) {
            id
            type
          }
        }
        fromTravel @include(if: $withRedirectsFromTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          availabilityStatus @include(if: $withRedirectsFromTravelAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          executionStatus
          travelConsultant @include(if: $withRedirectsFromTravelTravelConsultant) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          label @include(if: $withRedirectsFromTravelLabel) {
            id
            label
          }
          title
          description
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          seoSettings @include(if: $withRedirectsFromTravelSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          tenantSettings @include(if: $withRedirectsFromTravelTenantSettings) {
            id
            onlineStatus
            redirectToBooking
            useTiming
            startDate
            endDate
          }
          highlights @include(if: $withRedirectsFromTravelHighlights) {
            id
            text
          }
          partners @include(if: $withRedirectsFromTravelPartners) {
            id
            name
            url
            logoWidth
          }
          travelGuides @include(if: $withRedirectsFromTravelTravelGuides) {
            id
            firstName
            lastName
            description
          }
          teams @include(if: $withRedirectsFromTravelTeams) {
            id
            name
          }
          accommodationAssignments @include(if: $withRedirectsFromTravelAccommodationAssignments) {
            id
            useCustomRoomTypeSelection
          }
          accommodations @include(if: $withRedirectsFromTravelAccommodations) {
            id
            label
            name
            stars
            description
          }
          destinations @include(if: $withRedirectsFromTravelDestinations) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          testimonials @include(if: $withRedirectsFromTravelTestimonials) {
            id
          }
          mainImage @include(if: $withRedirectsFromTravelMainImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mainVideo @include(if: $withRedirectsFromTravelMainVideo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          gallery @include(if: $withRedirectsFromTravelGallery) {
            id
          }
          travelPdf @include(if: $withRedirectsFromTravelTravelPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          travelExtensions @include(if: $withRedirectsFromTravelTravelExtensions) {
            id
            duration
            name
            description
          }
          programType
          itinerary @include(if: $withRedirectsFromTravelItinerary) {
            id
          }
          programText
          pricing @include(if: $withRedirectsFromTravelPricing) {
            id
            isTravelDocumentationAvailable
          }
          minPrice
          minPriceManualOverride
          currency
        }
        toType
        toUrl
        toPage @include(if: $withRedirectsToPage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withRedirectsToPageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withRedirectsToPageContentBlockAssignments) {
            id
            type
          }
        }
        toTravel @include(if: $withRedirectsToTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          availabilityStatus @include(if: $withRedirectsToTravelAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          executionStatus
          travelConsultant @include(if: $withRedirectsToTravelTravelConsultant) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          label @include(if: $withRedirectsToTravelLabel) {
            id
            label
          }
          title
          description
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          seoSettings @include(if: $withRedirectsToTravelSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          tenantSettings @include(if: $withRedirectsToTravelTenantSettings) {
            id
            onlineStatus
            redirectToBooking
            useTiming
            startDate
            endDate
          }
          highlights @include(if: $withRedirectsToTravelHighlights) {
            id
            text
          }
          partners @include(if: $withRedirectsToTravelPartners) {
            id
            name
            url
            logoWidth
          }
          travelGuides @include(if: $withRedirectsToTravelTravelGuides) {
            id
            firstName
            lastName
            description
          }
          teams @include(if: $withRedirectsToTravelTeams) {
            id
            name
          }
          accommodationAssignments @include(if: $withRedirectsToTravelAccommodationAssignments) {
            id
            useCustomRoomTypeSelection
          }
          accommodations @include(if: $withRedirectsToTravelAccommodations) {
            id
            label
            name
            stars
            description
          }
          destinations @include(if: $withRedirectsToTravelDestinations) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          testimonials @include(if: $withRedirectsToTravelTestimonials) {
            id
          }
          mainImage @include(if: $withRedirectsToTravelMainImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mainVideo @include(if: $withRedirectsToTravelMainVideo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          gallery @include(if: $withRedirectsToTravelGallery) {
            id
          }
          travelPdf @include(if: $withRedirectsToTravelTravelPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          travelExtensions @include(if: $withRedirectsToTravelTravelExtensions) {
            id
            duration
            name
            description
          }
          programType
          itinerary @include(if: $withRedirectsToTravelItinerary) {
            id
          }
          programText
          pricing @include(if: $withRedirectsToTravelPricing) {
            id
            isTravelDocumentationAvailable
          }
          minPrice
          minPriceManualOverride
          currency
        }
      }
      onlinePaymentConfig @include(if: $withOnlinePaymentConfig) {
        id
        enabled
        ratioFibuAccountNo
        infoText
        datatransThemeConfig
      }
      ratioConfig @include(if: $withRatioConfig) {
        id
        adressgruppe
      }
      content @include(if: $withContent) {
        id
        bookingInsuranceInfo
      }
      partnerTenants @include(if: $withPartnerTenants) {
        id
        tenant @include(if: $withPartnerTenantsTenant) {
          id
          name
          slug
          domain
          externalReference
          cms @include(if: $withPartnerTenantsTenantCms) {
            id
          }
          travelTypes @include(if: $withPartnerTenantsTenantTravelTypes) {
            id
            name
            description
          }
          employees @include(if: $withPartnerTenantsTenantEmployees) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          emailConfig @include(if: $withPartnerTenantsTenantEmailConfig) {
            id
            defaultInternalRecipientEmail
            internalBookingRecipientEmails
            bookingConfirmationTemplateId
            bookingConfirmationInternalTemplateId
            bookingRequestConfirmationTemplateId
            bookingWaitlistConfirmationTemplateId
            bookingWaitlistContingentCheckConfirmationTemplateId
            bookingCustomRequestTemplateId
            bookingPassportDataReminderTemplateId
            contactFormTemplateId
            esimInstallationInfoTemplateId
          }
          newsletterProvider @include(if: $withPartnerTenantsTenantNewsletterProvider) {
            id
            provider
          }
          redirects @include(if: $withPartnerTenantsTenantRedirects) {
            id
            fromType
            fromUrl
            toType
            toUrl
          }
          onlinePaymentConfig @include(if: $withPartnerTenantsTenantOnlinePaymentConfig) {
            id
            enabled
            ratioFibuAccountNo
            infoText
            datatransThemeConfig
          }
          ratioConfig @include(if: $withPartnerTenantsTenantRatioConfig) {
            id
            adressgruppe
          }
          content @include(if: $withPartnerTenantsTenantContent) {
            id
            bookingInsuranceInfo
          }
          partnerTenants @include(if: $withPartnerTenantsTenantPartnerTenants) {
            id
            filterCrossLinking
          }
        }
        filterCrossLinking
      }
    }
  }`

// language=GraphQL
export const UPDATE_TENANT_MUTATION = `
  mutation Mutation($input: UpdateTenantInput, $withCms: Boolean = false, $withCmsHomepage: Boolean = false, $withCmsHomepageSeoSettings: Boolean = false, $withCmsHomepageContentBlockAssignments: Boolean = false, $withCmsCategories: Boolean = false, $withCmsCategoriesPages: Boolean = false, $withCmsCategoriesSeoSettings: Boolean = false, $withCmsPages: Boolean = false, $withCmsPagesSeoSettings: Boolean = false, $withCmsPagesContentBlockAssignments: Boolean = false, $withCmsErrorPage404: Boolean = false, $withCmsErrorPage404SeoSettings: Boolean = false, $withCmsErrorPage404ContentBlockAssignments: Boolean = false, $withCmsErrorPage500: Boolean = false, $withCmsErrorPage500SeoSettings: Boolean = false, $withCmsErrorPage500ContentBlockAssignments: Boolean = false, $withCmsConfig: Boolean = false, $withCmsConfigContactBlockSettings: Boolean = false, $withCmsConfigSocialMediaSettings: Boolean = false, $withCmsConfigPrivacyPolicyPage: Boolean = false, $withCmsConfigGtcPage: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false, $withEmployees: Boolean = false, $withEmployeesImage: Boolean = false, $withEmailConfig: Boolean = false, $withNewsletterProvider: Boolean = false, $withNewsletterProviderConfig: Boolean = false, $withRedirects: Boolean = false, $withRedirectsFromPage: Boolean = false, $withRedirectsFromPageSeoSettings: Boolean = false, $withRedirectsFromPageContentBlockAssignments: Boolean = false, $withRedirectsFromTravel: Boolean = false, $withRedirectsFromTravelAvailabilityStatus: Boolean = false, $withRedirectsFromTravelTravelConsultant: Boolean = false, $withRedirectsFromTravelLabel: Boolean = false, $withRedirectsFromTravelSeoSettings: Boolean = false, $withRedirectsFromTravelTenantSettings: Boolean = false, $withRedirectsFromTravelHighlights: Boolean = false, $withRedirectsFromTravelPartners: Boolean = false, $withRedirectsFromTravelTravelGuides: Boolean = false, $withRedirectsFromTravelTeams: Boolean = false, $withRedirectsFromTravelAccommodationAssignments: Boolean = false, $withRedirectsFromTravelAccommodations: Boolean = false, $withRedirectsFromTravelDestinations: Boolean = false, $withRedirectsFromTravelTestimonials: Boolean = false, $withRedirectsFromTravelMainImage: Boolean = false, $withRedirectsFromTravelMainVideo: Boolean = false, $withRedirectsFromTravelGallery: Boolean = false, $withRedirectsFromTravelTravelPdf: Boolean = false, $withRedirectsFromTravelTravelExtensions: Boolean = false, $withRedirectsFromTravelItinerary: Boolean = false, $withRedirectsFromTravelPricing: Boolean = false, $withRedirectsToPage: Boolean = false, $withRedirectsToPageSeoSettings: Boolean = false, $withRedirectsToPageContentBlockAssignments: Boolean = false, $withRedirectsToTravel: Boolean = false, $withRedirectsToTravelAvailabilityStatus: Boolean = false, $withRedirectsToTravelTravelConsultant: Boolean = false, $withRedirectsToTravelLabel: Boolean = false, $withRedirectsToTravelSeoSettings: Boolean = false, $withRedirectsToTravelTenantSettings: Boolean = false, $withRedirectsToTravelHighlights: Boolean = false, $withRedirectsToTravelPartners: Boolean = false, $withRedirectsToTravelTravelGuides: Boolean = false, $withRedirectsToTravelTeams: Boolean = false, $withRedirectsToTravelAccommodationAssignments: Boolean = false, $withRedirectsToTravelAccommodations: Boolean = false, $withRedirectsToTravelDestinations: Boolean = false, $withRedirectsToTravelTestimonials: Boolean = false, $withRedirectsToTravelMainImage: Boolean = false, $withRedirectsToTravelMainVideo: Boolean = false, $withRedirectsToTravelGallery: Boolean = false, $withRedirectsToTravelTravelPdf: Boolean = false, $withRedirectsToTravelTravelExtensions: Boolean = false, $withRedirectsToTravelItinerary: Boolean = false, $withRedirectsToTravelPricing: Boolean = false, $withOnlinePaymentConfig: Boolean = false, $withRatioConfig: Boolean = false, $withContent: Boolean = false, $withPartnerTenants: Boolean = false, $withPartnerTenantsTenant: Boolean = false, $withPartnerTenantsTenantCms: Boolean = false, $withPartnerTenantsTenantTravelTypes: Boolean = false, $withPartnerTenantsTenantEmployees: Boolean = false, $withPartnerTenantsTenantEmailConfig: Boolean = false, $withPartnerTenantsTenantNewsletterProvider: Boolean = false, $withPartnerTenantsTenantRedirects: Boolean = false, $withPartnerTenantsTenantOnlinePaymentConfig: Boolean = false, $withPartnerTenantsTenantRatioConfig: Boolean = false, $withPartnerTenantsTenantContent: Boolean = false, $withPartnerTenantsTenantPartnerTenants: Boolean = false) {
    tenant: updateTenant(input: $input) {
      id
      name
      slug
      domain
      externalReference
      cms @include(if: $withCms) {
        id
        homepage @include(if: $withCmsHomepage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withCmsHomepageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withCmsHomepageContentBlockAssignments) {
            id
            type
          }
        }
        categories @include(if: $withCmsCategories) {
          id
          name
          pages @include(if: $withCmsCategoriesPages) {
            id
            name
            onlineStatus
          }
          seoSettings @include(if: $withCmsCategoriesSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
        }
        pages @include(if: $withCmsPages) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withCmsPagesSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withCmsPagesContentBlockAssignments) {
            id
            type
          }
        }
        errorPage404 @include(if: $withCmsErrorPage404) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withCmsErrorPage404SeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withCmsErrorPage404ContentBlockAssignments) {
            id
            type
          }
        }
        errorPage500 @include(if: $withCmsErrorPage500) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withCmsErrorPage500SeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withCmsErrorPage500ContentBlockAssignments) {
            id
            type
          }
        }
        config @include(if: $withCmsConfig) {
          id
          contactBlockSettings @include(if: $withCmsConfigContactBlockSettings) {
            id
            slogan
            title
            text
            phonePrefix
            phone
            phone2Prefix
            phone2
            openingHours1
            openingHours2
            email
          }
          socialMediaSettings @include(if: $withCmsConfigSocialMediaSettings) {
            id
            facebookUrl
            instagramUrl
          }
          privacyPolicyPage @include(if: $withCmsConfigPrivacyPolicyPage) {
            id
            name
            onlineStatus
          }
          gtcPage @include(if: $withCmsConfigGtcPage) {
            id
            name
            onlineStatus
          }
        }
      }
      travelTypes @include(if: $withTravelTypes) {
        id
        name
        description
        image @include(if: $withTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      employees @include(if: $withEmployees) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withEmployeesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      emailConfig @include(if: $withEmailConfig) {
        id
        defaultInternalRecipientEmail
        internalBookingRecipientEmails
        bookingConfirmationTemplateId
        bookingConfirmationInternalTemplateId
        bookingRequestConfirmationTemplateId
        bookingWaitlistConfirmationTemplateId
        bookingWaitlistContingentCheckConfirmationTemplateId
        bookingCustomRequestTemplateId
        bookingPassportDataReminderTemplateId
        contactFormTemplateId
        esimInstallationInfoTemplateId
      }
      newsletterProvider @include(if: $withNewsletterProvider) {
        id
        provider
        config @include(if: $withNewsletterProviderConfig) {
          __typename
          ... on MailchimpConfig {
            id
            apiKey
            serverPrefix
            listId

          }
        }
      }
      redirects @include(if: $withRedirects) {
        id
        fromType
        fromUrl
        fromPage @include(if: $withRedirectsFromPage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withRedirectsFromPageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withRedirectsFromPageContentBlockAssignments) {
            id
            type
          }
        }
        fromTravel @include(if: $withRedirectsFromTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          availabilityStatus @include(if: $withRedirectsFromTravelAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          executionStatus
          travelConsultant @include(if: $withRedirectsFromTravelTravelConsultant) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          label @include(if: $withRedirectsFromTravelLabel) {
            id
            label
          }
          title
          description
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          seoSettings @include(if: $withRedirectsFromTravelSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          tenantSettings @include(if: $withRedirectsFromTravelTenantSettings) {
            id
            onlineStatus
            redirectToBooking
            useTiming
            startDate
            endDate
          }
          highlights @include(if: $withRedirectsFromTravelHighlights) {
            id
            text
          }
          partners @include(if: $withRedirectsFromTravelPartners) {
            id
            name
            url
            logoWidth
          }
          travelGuides @include(if: $withRedirectsFromTravelTravelGuides) {
            id
            firstName
            lastName
            description
          }
          teams @include(if: $withRedirectsFromTravelTeams) {
            id
            name
          }
          accommodationAssignments @include(if: $withRedirectsFromTravelAccommodationAssignments) {
            id
            useCustomRoomTypeSelection
          }
          accommodations @include(if: $withRedirectsFromTravelAccommodations) {
            id
            label
            name
            stars
            description
          }
          destinations @include(if: $withRedirectsFromTravelDestinations) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          testimonials @include(if: $withRedirectsFromTravelTestimonials) {
            id
          }
          mainImage @include(if: $withRedirectsFromTravelMainImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mainVideo @include(if: $withRedirectsFromTravelMainVideo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          gallery @include(if: $withRedirectsFromTravelGallery) {
            id
          }
          travelPdf @include(if: $withRedirectsFromTravelTravelPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          travelExtensions @include(if: $withRedirectsFromTravelTravelExtensions) {
            id
            duration
            name
            description
          }
          programType
          itinerary @include(if: $withRedirectsFromTravelItinerary) {
            id
          }
          programText
          pricing @include(if: $withRedirectsFromTravelPricing) {
            id
            isTravelDocumentationAvailable
          }
          minPrice
          minPriceManualOverride
          currency
        }
        toType
        toUrl
        toPage @include(if: $withRedirectsToPage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withRedirectsToPageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withRedirectsToPageContentBlockAssignments) {
            id
            type
          }
        }
        toTravel @include(if: $withRedirectsToTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          availabilityStatus @include(if: $withRedirectsToTravelAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          executionStatus
          travelConsultant @include(if: $withRedirectsToTravelTravelConsultant) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          label @include(if: $withRedirectsToTravelLabel) {
            id
            label
          }
          title
          description
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          seoSettings @include(if: $withRedirectsToTravelSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          tenantSettings @include(if: $withRedirectsToTravelTenantSettings) {
            id
            onlineStatus
            redirectToBooking
            useTiming
            startDate
            endDate
          }
          highlights @include(if: $withRedirectsToTravelHighlights) {
            id
            text
          }
          partners @include(if: $withRedirectsToTravelPartners) {
            id
            name
            url
            logoWidth
          }
          travelGuides @include(if: $withRedirectsToTravelTravelGuides) {
            id
            firstName
            lastName
            description
          }
          teams @include(if: $withRedirectsToTravelTeams) {
            id
            name
          }
          accommodationAssignments @include(if: $withRedirectsToTravelAccommodationAssignments) {
            id
            useCustomRoomTypeSelection
          }
          accommodations @include(if: $withRedirectsToTravelAccommodations) {
            id
            label
            name
            stars
            description
          }
          destinations @include(if: $withRedirectsToTravelDestinations) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          testimonials @include(if: $withRedirectsToTravelTestimonials) {
            id
          }
          mainImage @include(if: $withRedirectsToTravelMainImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mainVideo @include(if: $withRedirectsToTravelMainVideo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          gallery @include(if: $withRedirectsToTravelGallery) {
            id
          }
          travelPdf @include(if: $withRedirectsToTravelTravelPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          travelExtensions @include(if: $withRedirectsToTravelTravelExtensions) {
            id
            duration
            name
            description
          }
          programType
          itinerary @include(if: $withRedirectsToTravelItinerary) {
            id
          }
          programText
          pricing @include(if: $withRedirectsToTravelPricing) {
            id
            isTravelDocumentationAvailable
          }
          minPrice
          minPriceManualOverride
          currency
        }
      }
      onlinePaymentConfig @include(if: $withOnlinePaymentConfig) {
        id
        enabled
        ratioFibuAccountNo
        infoText
        datatransThemeConfig
      }
      ratioConfig @include(if: $withRatioConfig) {
        id
        adressgruppe
      }
      content @include(if: $withContent) {
        id
        bookingInsuranceInfo
      }
      partnerTenants @include(if: $withPartnerTenants) {
        id
        tenant @include(if: $withPartnerTenantsTenant) {
          id
          name
          slug
          domain
          externalReference
          cms @include(if: $withPartnerTenantsTenantCms) {
            id
          }
          travelTypes @include(if: $withPartnerTenantsTenantTravelTypes) {
            id
            name
            description
          }
          employees @include(if: $withPartnerTenantsTenantEmployees) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          emailConfig @include(if: $withPartnerTenantsTenantEmailConfig) {
            id
            defaultInternalRecipientEmail
            internalBookingRecipientEmails
            bookingConfirmationTemplateId
            bookingConfirmationInternalTemplateId
            bookingRequestConfirmationTemplateId
            bookingWaitlistConfirmationTemplateId
            bookingWaitlistContingentCheckConfirmationTemplateId
            bookingCustomRequestTemplateId
            bookingPassportDataReminderTemplateId
            contactFormTemplateId
            esimInstallationInfoTemplateId
          }
          newsletterProvider @include(if: $withPartnerTenantsTenantNewsletterProvider) {
            id
            provider
          }
          redirects @include(if: $withPartnerTenantsTenantRedirects) {
            id
            fromType
            fromUrl
            toType
            toUrl
          }
          onlinePaymentConfig @include(if: $withPartnerTenantsTenantOnlinePaymentConfig) {
            id
            enabled
            ratioFibuAccountNo
            infoText
            datatransThemeConfig
          }
          ratioConfig @include(if: $withPartnerTenantsTenantRatioConfig) {
            id
            adressgruppe
          }
          content @include(if: $withPartnerTenantsTenantContent) {
            id
            bookingInsuranceInfo
          }
          partnerTenants @include(if: $withPartnerTenantsTenantPartnerTenants) {
            id
            filterCrossLinking
          }
        }
        filterCrossLinking
      }
    }
  }`

// language=GraphQL
export const DELETE_TENANT_MUTATION = `
  mutation Mutation($input: DeleteTenantInput) {
    deleteTenant(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TENANT_MUTATION = `
  mutation Mutation($input: DeleteTenantInput) {
    forceDeleteTenant(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_TENANT_TRAVEL_TYPES_MUTATION = `
  mutation Mutation($input: addTenantTravelTypesInput) {
    addTenantTravelTypes(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const REMOVE_TENANT_TRAVEL_TYPES_MUTATION = `
  mutation Mutation($input: removeTenantTravelTypesInput) {
    removeTenantTravelTypes(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const CREATE_TENANT_TRAVEL_TYPES_MUTATION = `
  mutation Mutation($input: createTenantTravelTypesInput) {
    createTenantTravelTypes(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const DELETE_TENANT_TRAVEL_TYPES_MUTATION = `
  mutation Mutation($input: deleteTenantTravelTypesInput) {
    deleteTenantTravelTypes(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const UPDATE_TENANT_TRAVEL_TYPES_ORDER_MUTATION = `
  mutation Mutation($input: updateTenantTravelTypesOrderInput) {
    updateTenantTravelTypesOrder(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const ADD_TENANT_EMPLOYEES_MUTATION = `
  mutation Mutation($input: addTenantEmployeesInput) {
    addTenantEmployees(input: $input) {
      id
      employeeIds
    }
  }`

// language=GraphQL
export const REMOVE_TENANT_EMPLOYEES_MUTATION = `
  mutation Mutation($input: removeTenantEmployeesInput) {
    removeTenantEmployees(input: $input) {
      id
      employeeIds
    }
  }`

// language=GraphQL
export const CREATE_TENANT_EMPLOYEES_MUTATION = `
  mutation Mutation($input: createTenantEmployeesInput) {
    createTenantEmployees(input: $input) {
      id
      employeeIds
    }
  }`

// language=GraphQL
export const DELETE_TENANT_EMPLOYEES_MUTATION = `
  mutation Mutation($input: deleteTenantEmployeesInput) {
    deleteTenantEmployees(input: $input) {
      id
      employeeIds
    }
  }`

// language=GraphQL
export const UPDATE_TENANT_EMPLOYEES_ORDER_MUTATION = `
  mutation Mutation($input: updateTenantEmployeesOrderInput) {
    updateTenantEmployeesOrder(input: $input) {
      id
      employeeIds
    }
  }`

// language=GraphQL
export const ADD_TENANT_REDIRECTS_MUTATION = `
  mutation Mutation($input: addTenantRedirectsInput) {
    addTenantRedirects(input: $input) {
      id
      redirectIds
    }
  }`

// language=GraphQL
export const REMOVE_TENANT_REDIRECTS_MUTATION = `
  mutation Mutation($input: removeTenantRedirectsInput) {
    removeTenantRedirects(input: $input) {
      id
      redirectIds
    }
  }`

// language=GraphQL
export const CREATE_TENANT_REDIRECTS_MUTATION = `
  mutation Mutation($input: createTenantRedirectsInput) {
    createTenantRedirects(input: $input) {
      id
      redirectIds
    }
  }`

// language=GraphQL
export const DELETE_TENANT_REDIRECTS_MUTATION = `
  mutation Mutation($input: deleteTenantRedirectsInput) {
    deleteTenantRedirects(input: $input) {
      id
      redirectIds
    }
  }`

// language=GraphQL
export const UPDATE_TENANT_REDIRECTS_ORDER_MUTATION = `
  mutation Mutation($input: updateTenantRedirectsOrderInput) {
    updateTenantRedirectsOrder(input: $input) {
      id
      redirectIds
    }
  }`

// language=GraphQL
export const ADD_TENANT_PARTNER_TENANTS_MUTATION = `
  mutation Mutation($input: addTenantPartnerTenantsInput) {
    addTenantPartnerTenants(input: $input) {
      id
      partnerTenantIds
    }
  }`

// language=GraphQL
export const REMOVE_TENANT_PARTNER_TENANTS_MUTATION = `
  mutation Mutation($input: removeTenantPartnerTenantsInput) {
    removeTenantPartnerTenants(input: $input) {
      id
      partnerTenantIds
    }
  }`

// language=GraphQL
export const CREATE_TENANT_PARTNER_TENANTS_MUTATION = `
  mutation Mutation($input: createTenantPartnerTenantsInput) {
    createTenantPartnerTenants(input: $input) {
      id
      partnerTenantIds
    }
  }`

// language=GraphQL
export const DELETE_TENANT_PARTNER_TENANTS_MUTATION = `
  mutation Mutation($input: deleteTenantPartnerTenantsInput) {
    deleteTenantPartnerTenants(input: $input) {
      id
      partnerTenantIds
    }
  }`

// language=GraphQL
export const UPDATE_TENANT_PARTNER_TENANTS_ORDER_MUTATION = `
  mutation Mutation($input: updateTenantPartnerTenantsOrderInput) {
    updateTenantPartnerTenantsOrder(input: $input) {
      id
      partnerTenantIds
    }
  }`

// language=GraphQL
export const TENANTS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelObjectTenantSettings: Boolean = false, $withAvailabilityStatusTenantSettings: Boolean = false, $withBookings: Boolean = false, $withOnlinePayments: Boolean = false, $withTrackingConversions: Boolean = false, $withPartnerTenants: Boolean = false) {
  groupedDependents: tenantDependents(id: $id) {
    travelObjectTenantSettings @include(if: $withTravelObjectTenantSettings) {
      id
      onlineStatus
      redirectToBooking
      useTiming
      startDate
      endDate
    }
    availabilityStatusTenantSettings @include(if: $withAvailabilityStatusTenantSettings) {
      id
      label
      info
      switchToStatusInfo
      submitButtonLabel    }
    bookings @include(if: $withBookings) {
      id
      referenceNo
      travellerRemarks
      travellerDataCorrectnessConfirmation
      localState
      backofficePayload
      backofficeResponse
      transmissionStatus
      webhookStatus
      webhookResponse
      webhookDuration
      confirmationEmailSent
      isPassportDataRequired
      passportDataReminderEmailSent
      passportDataReceived    }
    onlinePayments @include(if: $withOnlinePayments) {
      id
      transactionId
      transactionStatus
      submittedToBackoffice
      statusPayload    }
    trackingConversions @include(if: $withTrackingConversions) {
      id
      sessionId
      conversionName
      conversionTime
      conversionValue
      conversionCurrency
      tourName
      tourId
      bookingId
      landingPageUrl
      source
      medium
      utmSource
      utmMedium
      utmCampaign
      utmTerm
      utmContent
      gclid
      gbraid
      msclkid
      fbclid
      ttclid
      scclid
      liFatId
      acquisitionTimestamp
    }
    partnerTenants @include(if: $withPartnerTenants) {
      id
      filterCrossLinking    }
  }
}`
